import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography, Box } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import CreateAccount from './CreateAccount';
import ChooseSubscription from './ChooseSubscription';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const useStyles = theme => ({
    root: {
        position: 'relative',
        // top: '-48px',
        paddingTop: '0',
        padding: '3%',
    },
    button: {
        marginTop: theme.spacing(2),
        width: '100px',
        backgroundColor: '#47a0c4',
        fontSize: '15px',
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#0ba8cd',
            color: '#FFFFFF'
        },
    },
    textfield: {
        margin: theme.spacing(1),
        width: '250px',
        backgroundColor: '#ffffff'
    },
    emailIdField: {
        margin: theme.spacing(1),
        width: '520px'
    },
    website: {
        margin: theme.spacing(1),
        width: '520px',
        backgroundColor: '#ffffff'
    },
    nextbutton: {
        align: 'right',
        marginTop: theme.spacing(2),
        marginLeft: '857px',
        width: '100px',
        backgroundColor: '#47a0c4',
        fontSize: '15px',
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#0ba8cd',
            color: '#FFFFFF'
        },
    }
});

class CompanyInformation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            comapnyInformation: true,
            createAccount: false,
            chooseSubscription: false,
            businessName: '',
            businessPhoneNumber: '',
            businessEmailAddress: '',
            address: '',
            city: '',
            stateRegion: '',
            postalCode: '',
            country: '',
            website: '',
            locations: '',
            sites: '',
            businessType: '',
            annualVolume: '',
            formValid: false
        }
    }

    async componentDidMount() {
        console.log(this.props.username)
    }

    handleBusinessTypeChange = (event) => {
        // this.setState({ businessType: event.target.value}
        this.setState({
            formValid: false,
            businessType: event.target.value,
        }, () => {
            this.handleFormValidation();
        });
    };

    handleFormChange = (event) => {
        this.setState({
            formValid: false,
            [event.target.id]: event.target.value,
        }, () => {
            this.handleFormValidation();
        });
    };

    handleFormValidation = () => {
        if (this.state.businessName && this.state.businessPhoneNumber.length === 10 && this.state.businessEmailAddress && this.state.address && this.state.city && this.state.stateRegion && 
            this.state.postalCode.length && this.state.country && this.state.website && this.state.locations && this.state.sites && this.state.businessType && this.state.annualVolume) {
            this.setState({ formValid: true });
        } else if (this.state.isFormValidSave) {
            this.setState({ formValid: false });
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <>
                {this.state.createAccount
                    ? <CreateAccount />
                    : null}

                {this.state.chooseSubscription
                    ? <ChooseSubscription firstName={this.props.firstName} lastName={this.props.lastName} emailId={this.props.emailId} password={this.props.password} 
                        phoneNumber={this.props.phoneNumber} username={this.props.username} businessName={this.state.businessName} businessPhoneNumber={this.state.businessPhoneNumber} 
                        businessEmailAddress={this.state.businessEmailAddress} address={this.state.address} city={this.state.city} stateRegion={this.state.stateRegion} postalCode={this.state.postalCode}
                        country={this.state.country} website={this.state.website} locations={this.state.locations} sites={this.state.sites} businessType={this.state.businessType}
                        annualVolume={this.state.annualVolume}/>
                    : null}

                {this.state.comapnyInformation
                    ? <Grid container className={classes.root}>
                        <Box style={{ height: '50px', display: 'flex', flexDirection: 'row', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem' }} >
                                1. Create Account
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#47a0c4', fontSize: '1.3rem', marginLeft: '10%' }} >
                                2. Company Information
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                3. Choose a Subscription
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                4. Complete
                            </Typography>
                        </Box>

                        <Box style={{ height: '500px', display: 'flex', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                            <Grid>
                                <Grid container style={{ justifyContent: 'center' }}>
                                    <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.7rem', fontWeight: 'bold' }} >
                                        Provide your Company Information
                                    </Typography>
                                </Grid>
                                <Grid container>
                                    <TextField id="businessName" required label="Business Name" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px' }} />

                                    <TextField id="businessPhoneNumber" required label="Phone Number" type="number"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginLeft: '20px', marginTop: '20px' }} />

                                    <TextField id="businessEmailAddress" required label="Email Address" type="email"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginLeft: '20px', marginTop: '20px' }} />
                                </Grid><br />
                                <Grid container>
                                    <TextField id="address" required label="Location Address" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px' }} />

                                    <TextField id="city" required label="City" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px', marginLeft: '20px' }} />

                                    <TextField id="stateRegion" required label="State/Region" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px', marginLeft: '20px' }} />

                                    <TextField id="postalCode" required label="Postal Code" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px', marginLeft: '20px' }} />
                                </Grid><br />
                                <Grid container>
                                    <TextField id="country" required label="Country" type="text"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px' }} />

                                    <TextField id="website" required label="Website" type="text"
                                        className={classes.website} onChange={this.handleFormChange} style={{ marginLeft: '20px', marginTop: '20px' }} />
                                </Grid><br />
                                <Grid container>
                                    <TextField id="locations" required label="Total number of locations" type="number"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px' }} />

                                    <TextField id="sites" required label="total number of sites" type="number"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginLeft: '20px', marginTop: '20px' }} />

                                    {/* <TextField id="businessType" required label="Business Type" type="text"
                                        className={classes.textfield} onChange={this._handleChangeSaveCard} style={{ marginLeft: '20px', marginTop: '20px' }} /> */}
                                    <FormControl className={classes.textfield} style={{ marginLeft: '20px', marginTop: '20px' }}>
                                        <InputLabel id="demo-simple-select-label">Business Type</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={this.state.businessType}
                                            label="Business Type"
                                            onChange={this.handleBusinessTypeChange}
                                        >
                                            <MenuItem value={"RV Park"}>RV Park</MenuItem>
                                            <MenuItem value={"Campground"}>Campground</MenuItem>
                                            <MenuItem value={"Marina"}>Marina</MenuItem>
                                            <MenuItem value={"Event Organizer"}>Event Organizer</MenuItem>
                                            <MenuItem value={"Glamping Resort"}>Glamping Resort</MenuItem>
                                            <MenuItem value={"Lodges and Cabins"}>Lodges and Cabins</MenuItem>
                                            <MenuItem value={"Camping Clubs"}>Camping Clubs</MenuItem>
                                            <MenuItem value={"Government"}>Government</MenuItem>
                                            <MenuItem value={"Adventure Groups"}>Adventure Groups</MenuItem>
                                            <MenuItem value={"Gated Community"}>55+ Gated Community</MenuItem>
                                            <MenuItem value={"Hotel or Motel"}>Hotel or Motel</MenuItem>
                                            <MenuItem value={"Golf Course"}>Golf Course</MenuItem>
                                            <MenuItem value={"Mobile Homes"}>Mobile Homes</MenuItem>
                                            <MenuItem value={"Parks"}>Parks</MenuItem>
                                            <MenuItem value={"Ranches"}>Ranches</MenuItem>
                                            <MenuItem value={"Resorts"}>Resorts</MenuItem>
                                            <MenuItem value={"Retreats"}>Retreats</MenuItem>
                                            <MenuItem value={"RV Resort"}>RV Resort</MenuItem>
                                            <MenuItem value={"State Park"}>State Park</MenuItem>
                                            <MenuItem value={"Vacation Rentals"}>Vacation Rentals</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <TextField id="annualVolume" required label="Annual Volume" type="number"
                                        className={classes.textfield} onChange={this.handleFormChange} style={{ marginLeft: '20px', marginTop: '20px' }} />
                                </Grid>
                                <Grid container>
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.setState({ createAccount: true, comapnyInformation: false }) }} >Back </Button>
                                    <Button variant="contained" color="primary" className={classes.nextbutton} onClick={() => { this.setState({ chooseSubscription: true, comapnyInformation: false }) }} disabled={!this.state.formValid}>Next </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    : null
                }
            </>
        );
    };
};

export default withStyles(useStyles)(CompanyInformation);